import { useEffect, useState, useCallback } from "react";
import api, { apiError } from "@/lib/api";
import { formatFCFA, formatDate } from "@/lib/format";
import { Loader, StatusBadge } from "@/components/common";
import { PageTitle, Panel } from "./AdminShell";
import { ORDER_STATUS, ORDER_STEPS, PAYMENT_STATUS } from "@/lib/labels";
import { toast } from "sonner";

export default function AdminOrders() {
  const [orders, setOrders] = useState(null);
  const [openId, setOpenId] = useState(null);
  const load = useCallback(() => api.get("/orders").then((r) => setOrders(r.data)), []);
  useEffect(() => { load(); }, [load]);

  const setStatus = async (id, status) => { try { await api.put(`/orders/${id}/status`, null, { params: { status } }); toast.success("Statut mis à jour"); load(); } catch (e) { toast.error(apiError(e)); } };
  const setPayment = async (id, payment_status) => { try { await api.put(`/orders/${id}/payment`, null, { params: { payment_status } }); toast.success("Paiement mis à jour"); load(); } catch (e) { toast.error(apiError(e)); } };

  if (!orders) return <Loader />;
  return (
    <div>
      <PageTitle>Commandes</PageTitle>
      <div className="space-y-2">
        {orders.map((o) => (
          <Panel key={o.id} className="p-4" data-testid={`admin-order-${o.id}`}>
            <div className="flex items-center gap-3 flex-wrap cursor-pointer" onClick={() => setOpenId(openId === o.id ? null : o.id)}>
              <span className="font-num font-bold">{o.order_number}</span>
              {o.from_reminder && <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-[#FDF3EE] text-[#C85A32] border border-[#C85A32]/30" data-testid={`order-reminder-badge-${o.id}`}>via relance</span>}
              <StatusBadge map={ORDER_STATUS} value={o.status} />
              <StatusBadge map={PAYMENT_STATUS} value={o.payment_status} />
              <span className="text-sm text-slate-500">{o.customer_name} · {o.zone}</span>
              <span className="ml-auto font-num font-bold text-[#C85A32]">{formatFCFA(o.total)}</span>
              <span className="text-xs text-slate-400">{formatDate(o.created_at)}</span>
            </div>
            {openId === o.id && (
              <div className="mt-3 pt-3 border-t border-slate-100">
                <div className="space-y-1 mb-3">
                  {o.items.map((i) => <div key={i.product_id} className="flex justify-between text-sm"><span>{i.quantity}× {i.name}</span><span className="font-num">{formatFCFA(i.price * i.quantity)}</span></div>)}
                </div>
                <div className="flex flex-wrap gap-3 items-end">
                  <label className="text-sm"><span className="block text-xs text-slate-500 mb-1">Statut commande</span>
                    <select value={o.status} onChange={(e) => setStatus(o.id, e.target.value)} className="border border-slate-300 rounded-lg px-3 py-2 text-sm" data-testid={`order-status-${o.id}`}>
                      {ORDER_STEPS.map((s) => <option key={s} value={s}>{ORDER_STATUS[s].label}</option>)}
                    </select>
                  </label>
                  <label className="text-sm"><span className="block text-xs text-slate-500 mb-1">Paiement</span>
                    <select value={o.payment_status} onChange={(e) => setPayment(o.id, e.target.value)} className="border border-slate-300 rounded-lg px-3 py-2 text-sm" data-testid={`order-payment-${o.id}`}>
                      {Object.keys(PAYMENT_STATUS).map((s) => <option key={s} value={s}>{PAYMENT_STATUS[s].label}</option>)}
                    </select>
                  </label>
                </div>
              </div>
            )}
          </Panel>
        ))}
      </div>
    </div>
  );
}
